import type { KGEdge } from '../../productintel/framework';
import { cn } from '../../lib/cn';

const KIND_COLORS: Record<string, string> = {
  accessory: 'border-brand-200 bg-brand-50 text-brand-700 dark:border-brand-800 dark:bg-brand-950 dark:text-brand-300',
  brand: 'border-purple-200 bg-purple-50 text-purple-700 dark:border-purple-800 dark:bg-purple-950 dark:text-purple-300',
  category: 'border-slate-200 bg-slate-50 text-slate-700 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-300',
  campaign: 'border-orange-200 bg-orange-50 text-orange-700 dark:border-orange-800 dark:bg-orange-950 dark:text-orange-300',
  competitor: 'border-error-200 bg-error-50 text-error-700 dark:border-error-900 dark:bg-error-950 dark:text-error-300',
  marketplace: 'border-success-200 bg-success-50 text-success-700 dark:border-success-900 dark:bg-success-950 dark:text-success-300',
};

type Props = {
  centerNode?: string;
  edges?: KGEdge[];
};

export function KnowledgeGraphPreview({
  centerNode = 'Premium Wireless Earbuds Pro',
  edges = [],
}: Props) {
  return (
    <div className="space-y-3">
      <div className="rounded-lg border-2 border-ai-300 bg-ai-50/30 px-4 py-3 text-center text-sm font-medium dark:border-ai-700 dark:bg-ai-950/30">
        {centerNode}
      </div>
      <div className="flex flex-wrap justify-center gap-2">
        {edges.map((e) => (
          <div key={`${e.from}-${e.to}-${e.kind}`} className="flex items-center gap-1 text-xs">
            <span className="text-slate-400">→</span>
            <span className={cn('rounded-lg border px-2 py-1', KIND_COLORS[e.kind] ?? 'border-slate-200')}>
              <span className="capitalize text-slate-400">{e.kind}: </span>
              {e.to}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
